import { rgba } from 'polished'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100vh;

  display: grid;
  grid-template-columns: 52% 48%;

  img {
    width: 100%;
    height: 100vh;

    object-fit: cover;
  }

  .content {
    padding: 4rem;
    overflow: auto;

    h1 {
      font-size: 4rem;
      word-break: break-word;
    }
    span {
      line-height: 100%;
      letter-spacing: 0.3rem;
    }
    p {
      line-height: 1.5;
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
    }

    .email-cta {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-top: 1rem;
      padding: 0.75rem 1.25rem;
      border-radius: 999px;
      background: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.text.title};
      font-weight: 600;
      letter-spacing: 0.04rem;
      text-decoration: none;
      transition: filter 0.2s ease;

      &:hover {
        filter: brightness(0.92);
      }
    }

    .links,
    .instagram-post-links {
      margin-top: 2rem;

      .swiper-container {
        height: 200px;
        margin-top: 1rem;

        .swiper-wrapper {
          align-items: center;

          .swiper-slide {
            width: 193px;
            height: 193px;
          }
        }
      }
    }

      .links .swiper-container .swiper-wrapper .swiper-slide {
        width: 250px;
      }

      .link,
      .post {
        width: 100%;
        height: 100%;
        /* padding: 1rem; */

        background: ${props => props.theme.colors.background.light};
        box-shadow: 0 18px 32px -8px rgba(19, 18, 32, 0.12);
        border-radius: 10px;

        display: flex;
        flex-direction: column;

        overflow: hidden;

        &:hover img {
          transform: scale(1.1) rotateZ(-4deg);
        }

        img {
          width: 100%;
          height: calc(100% - 3rem);
          object-fit: cover;

          filter: brightness(0.8);
          border-radius: 10px 10px 0 0;

          transition: all 0.4s ease;
        }

        span {
          width: 100%;
          height: 3rem;
          padding: 1rem;

          display: flex;
          align-items: center;

          color: ${props => props.theme.colors.text.title};
          border-radius: 0 0 10px 10px;

          line-height: 1.4rem;
          letter-spacing: 0.05rem;
          font-weight: 600;
          font-family: 'Poppins', sans-serif;
        }
      }
    }

    .instagram-post-links {
      .post {
        .swiper-container {
          height: auto;
          min-height: 200px;

          .swiper-wrapper .swiper-slide {
            height: calc(193px + 3rem);
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    display: block;
    height: 100%;
    max-height: 100vh;

    > img {
      opacity: 0.4;
      filter: saturate(0.2) blur(10px);
    }

    .content {
      position: absolute;
      top: 0%;
      width: 100%;
      height: 100%;
      max-height: 100vh;
      padding: 0rem;
      padding-bottom: 2rem;
      overflow: auto;

      color: rgba(255, 255, 255, 0.7);

      h1,
      span,
      p {
        padding: 2rem;
      }

      .email-cta {
        margin-left: 2rem;
      }

      .swiper-container {
        padding-left: 2rem;

        .link img,
        .post img {
          filter: brightness(1);
        }
      }
    }
  }
`
